<template>
    <!-- https://www.svgrepo.com/svg/512132/file-arrow-up-1612 -->
    <svg
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="#000000"
    >
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <title>file_arrow_up [#F09A0FFF]</title>
            <desc>Created with Sketch.</desc>
            <defs></defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Dribbble-Light-Preview" transform="translate(-420.000000, -1839.000000)" fill="#F09A0FFF">
                    <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path
                            d="M372,1695.0005 L374,1695.0005 L374,1689.0005 L367.907,1689.0005 L367.877,1691.0005 L370.634,1691.0005 L364,1697.6035 L365.393,1698.9985 L372,1692.3515 L372,1695.0005 Z M384,1685.0815 L384,1699.0005 L372,1699.0005 L372,1697.0005 L382,1697.0005 L382,1687.0005 L376,1687.0005 L376,1681.0005 L366,1681.0005 L366,1691.0005 L364,1691.0005 L364,1679.0005 L378,1679.0005 L384,1685.0815 Z"
                            id="file_arrow_up-[#F09A0FFF]"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "representativeFile",
};
</script>

<style scoped></style>
